import { Box, useMantineTheme } from '@mantine/core';
import { type FC, type PropsWithChildren } from 'react';
import type { SidebarWidthProps } from './types';

type Props = {
    isOpen: boolean;
    widthProps?: SidebarWidthProps;
};

export const RightSidebar: FC<PropsWithChildren<Props>> = ({
    isOpen,
    widthProps,
    children,
}) => {
    const theme = useMantineTheme();

    if (!isOpen) return null;

    const width = widthProps?.defaultWidth ?? 400;

    return (
        <Box
            component="aside"
            style={{
                width,
                minWidth: widthProps?.minWidth ?? 300,
                maxWidth: widthProps?.maxWidth ?? 800,
                height: '100vh',
                backgroundColor: theme.white,
                borderLeft: `1px solid ${theme.colors.gray[3]}`,
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 0,
                overflowY: 'auto',
            }}
        >
            {children}
        </Box>
    );
};
